import React from 'react'
import { Wrapper } from './PublicationList.styles'
import { ListPublicationItemPlaceholder } from '../ListPublicationItem'

const PublicationListPlaceholder = () => {
  return (
    <Wrapper>
      <ListPublicationItemPlaceholder />
      <ListPublicationItemPlaceholder />
      <ListPublicationItemPlaceholder />
      <ListPublicationItemPlaceholder />
    </Wrapper>
  )
}

export default PublicationListPlaceholder
